import { DateTime } from 'luxon';
import { PtLuxonDate } from '../projects/date.models';
import { ApiOption } from '../../_foundation/models/base.models';

export class VoyageLogSummary {
  id: number;
  localId?: number;
  startLocationId: number;
  startLocationName: string;
  startLocationAreaName: string;
  startOperationId: number;
  endOperationId?: number;
  startDate: DateTime;
  startDateShow: string;
  endLocationId: number;
  endLocationName: string;
  endLocationAreaName: string;
  endDate: DateTime;
  endDateShow: string;
  voyageNumber: number;
  distance: number;
  startCargoLoad: number;
  endCargoLoad: number;
  adjustment: number;
  significantPointData: SignificantPointGridModel[];
  completed: boolean;
  voyageDurationShow: string;

  // used to disable edit button in the log
  // log is only editable if the log is either 1. Incomplete, or 2. Completed (endDate) on the current daily log date. or 3. In implementer mode
  canEditRecord: boolean;
  // helper variable for showing loading icon
  significantPointsLoading: boolean;
}

export interface VoyageLogCreationValidation {
  canCreate: boolean;
  proposedVoyageNumber: number;
  precedingVoyageLogId?: number;
  precedingVoyageNumber?: number;
  followingVoyageLogId?: number;
  followingVoyageNumber?: number;
  reason?: string;
}

export class SignificantPointSummary {
  id: number;
  projectSpecificOperationId: number;
  stepId: number;
  componentWeight: number;
  dprContractCategory: string;
  operation: string;
  phaseName: string;
  phaseNumber: number;
  projectId: number;
  psoName: string;
  significantPoint: string;
  stageName: string;
  stageNumber: number;
  subClassification: string;
  vessels: string;
  dateTimeReached?: DateTime;
  dateTimeReachedOffset?: number;
  dateTimeReachedShow: string;
  isCustomAdjustment: boolean;
}

export class VoyageLogAdjustmentEditor {
  constructor(date: PtLuxonDate, voyageLogId: number) {
    this.date = date;
    this.dateOffset = date.dateTime.offset / 60;
    this.voyageLogId = voyageLogId;
  }

  id: number;
  guid: string;
  date: PtLuxonDate;
  dateOffset: number;
  timeToShow: string;
  locationId: number;
  projectSpecificOperationId: number;
  description: string;
  componentWeight?: number;
  voyageLogId: number;

  // for the ion selectable to work correctly
  selectedLocation: ApiOption<number>;
  selectedOperation: ApiOption<number>;
}

export class SignificantPointGridModel {
  id: number;
  guid: string;
  dateTimeReached?: Date;
  dateTimeReachedOffset?: number;
  dateTimeReachedShow: string;
  locationId: number;
  projectSpecificOperationId: number;
  locationName: string;
  projectSpecificOperationName: string;
  description: string;
  componentWeight?: number;
  voyageLogId: number;
  isCustomAdjustment: boolean;
}

export class VoyageLogAdjustmentMetadata {
  projectSpecificOperationOptions: ApiOption<number>[];
  locationOptions: ApiOption<number>[];
}



// WEBPACK FOOTER //
// ./src/models/voyage-log/voyagelog.models.ts